export default (theme) => {
  const { maxContentWidth } = theme.global

  return {
    container: {
      position: 'relative',
      overflow: 'auto',
    },

    foreground: {
      maxWidth: maxContentWidth,
      margin: '5rem auto',
      position: 'relative',
      zIndex: 5,
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
      },
    },

    background: {
      top: 0,
      left: 0,
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 2,
      backgroundSize: 'cover',
    },

    fullWidth: {
      margin: 0,
      width: '100%',
      maxWidth: 'unset',
    },

    transparent: {
      zIndex: 0,
    },
  }
}
